import React, { useEffect, useState } from 'react';
import Params from '../../../../../Types/ParamsPicklist';
import { Box, CircularProgress, Grid, TextField, Typography } from '@mui/material';
import { useAuthHeader, useAuthUser } from '../../../../../Services/Auth/sessionAuth';
import Utilisateur from '../../../../../Models/Utilisateur';
import SetMultipleDocument from '../../../../SetMultipleDocument';


let searchDocument  : Params = { CodeAgence: 'Ijara', Table: "vw_DocumentsParEtape", Colonne1: "CodeEtape", Colonne2: "", Colagence: 'CodeProcessus',Init:'MISE_EN_LOCATION', Choix: 34 }


function Tab5 (props: { form?: any }) {
  // USER SESSION
  const auth = useAuthUser()
  const user: Utilisateur = JSON.parse(JSON.stringify(auth()))

 
  return (
    <div className='tabItem'>
      <div >
        <Box fontStyle="inherit" className='border' width={"85%"} position={"absolute"}>
           <Grid item xs={12} md={12}  lg={12} >
                <SetMultipleDocument form={props.form}  Size="large"  width={4}  label="Documents"  name="Documents"  Parametre={searchDocument} />
             </Grid>
        </Box>
      </div>
    </div>
  )
}

export default Tab5;  

